// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1LFM9","cell":"ColumnAccessor_cell__1lL8h","firstCellAccent":"ColumnAccessor_firstCellAccent__1MNtN"};